import publisherApps from './views/create/PublisherApps';
import publisherAppEdit from './views/create/PublisherAppEdit';

const stylesPublisher = {
  publisherApps,
  publisherAppEdit,
};

export default stylesPublisher;
